import React from 'react';
import PropTypes from 'prop-types';
import { Row, Tooltip, Avatar, Dropdown } from 'antd';
import { InfoCircleOutlined, UserOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import { BtnLink } from '../../styles/Buttons';
import { useAuth } from '../../hooks/auth';

import { Container, Titulo, CaixaTitulo } from './styles';

function Cabecalho({ titleHeader, info, watch }) {
  const history = useHistory();
  const { usuario } = useAuth();
  const userLetter = usuario?.nome?.substr(0, 1);

  const menu = {
    items: [
      {
        key: 'editar-perfil',
        label: (
          <BtnLink
            style={{ width: '100%', textAlign: 'left', padding: 0 }}
            black="true"
            type="link"
            icon={<UserOutlined />}
            onClick={() => history.push('/perfil/editar')}
          >
            Editar meu perfil
          </BtnLink>
        ),
      },
    ],
  };

  return (
    <Container>
      <Row
        justify="space-between"
        align="middle"
        style={{
          flexDirection: 'row',
          width: '100%',
        }}
      >
        <Row
          justify={watch ? 'center' : 'start'}
          style={{
            width: '60%',
          }}
        >
          <CaixaTitulo>
            <Titulo level={2}>{titleHeader}</Titulo>
            {info && (
              <Tooltip
                placement="topLeft"
                title={info}
                arrowPointAtCenter
                className="icone"
              >
                <InfoCircleOutlined />
              </Tooltip>
            )}
          </CaixaTitulo>
        </Row>

        <Row
          justify="end"
          style={{
            width: '210px',
          }}
        >
          <Dropdown menu={menu} trigger={['click']}>
            <Row
              justify="center"
              align="center"
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                cursor: 'pointer',
                height: '100%',
                position: 'relative',
              }}
            >
              <Avatar
                style={{
                  verticalAlign: 'middle',
                }}
                size="large"
                gap={5}
              >
                {userLetter}
              </Avatar>
              <p
                style={{
                  margin: '0 10px',
                  whiteSpace: 'nowrap',
                  alignSelf: 'center',
                }}
              >
                {usuario.nome || ''}
              </p>
            </Row>
          </Dropdown>
        </Row>
      </Row>
    </Container>
  );
}

Cabecalho.propTypes = {
  titleHeader: PropTypes.node,
  info: PropTypes.node,
};

Cabecalho.defaultProps = {
  titleHeader: null,
  info: null,
};

export default Cabecalho;
